import { axiosWithAuth } from "../../helpers";

export const splitProfilesService = {
	addSplitProfile,
	getSplitProfile,
	editSplitProfile,
	getSplitProfileHistory,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getSplitProfile(agentId, splitProfileId) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/agents/${agentId}/residuals/split_profiles/${splitProfileId}`,
	});
}

function addSplitProfile(data) {
	return axiosWithAuth({
		method: "POST",
		data: JSON.stringify(data.payload),
		url: `${API_URL}/api/agents/${data.agentId}/residuals/split_profiles`,
	});
}

function editSplitProfile(data) {
	return axiosWithAuth({
		method: "PUT",
		data: JSON.stringify(data.payload),
		url: `${API_URL}/api/agents/${data.agentId}/residuals/split_profiles/${data.splitProfileId}`,
	});
}

function getSplitProfileHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/modifications/split_profiles/${id}`,
	};

	return axiosWithAuth(options);
}
